import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// After a new deploy, a stale HTML may request old chunk hashes that no
// longer exist, throwing "Importing a module script failed". Reload once
// so the browser picks up the new index.html and chunk graph.
const reloadOnChunkError = (msg: string | undefined) => {
  if (!msg) return;
  if (
    msg.includes("Importing a module script failed") ||
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("error loading dynamically imported module")
  ) {
    const key = "__chunk_reload_at";
    const last = Number(sessionStorage.getItem(key) || 0);
    if (Date.now() - last > 10000) {
      sessionStorage.setItem(key, String(Date.now()));
      window.location.reload();
    }
  }
};
window.addEventListener("error", (e) => reloadOnChunkError(e.message));
window.addEventListener("unhandledrejection", (e) =>
  reloadOnChunkError(String((e as PromiseRejectionEvent).reason?.message || ""))
);

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
